import { Button } from '@/shared/ui/Button'

type MissionsListEmptyProps = {
  filtered?: boolean
  onClearFilter?: () => void
}

export const MissionsListEmpty = ({
  filtered,
  onClearFilter
}: MissionsListEmptyProps) => (
  <div className="py-10 text-center">
    <p className="mb-2 text-sm font-bold text-gray-800">
      {filtered
        ? 'Nenhuma missão neste filtro'
        : 'Nenhuma missão disponível'}
    </p>
    <p className="mb-4 text-gray-500">
      {filtered
        ? 'Tente outro filtro para ver mais desafios.'
        : 'Volte mais tarde para descobrir novos desafios.'}
    </p>
    {filtered && onClearFilter && (
      <Button
        variant="secondary"
        size="sm"
        showTrailingIcon={false}
        onClick={onClearFilter}
      >
        Ver ativas
      </Button>
    )}
  </div>
)
